import { render } from "./popup-oeder.vue?vue&type=template&id=bf5b955a&scoped=true"
import script from "./popup-oeder.vue?vue&type=script&lang=js"
export * from "./popup-oeder.vue?vue&type=script&lang=js"

import "./popup-oeder.vue?vue&type=style&index=0&id=bf5b955a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-bf5b955a"

export default script